export const LOCKED = 'LOCKED';
export const AVAILABLE = 'AVAILABLE';

export const TRASFER_TIRES_ID ='14431';
export const TRASFER_TIRES_CODE ='RK_TD3';